import ApiCaller from 'actions/ApiCaller';
import baseConfig from 'actions/BaseAjaxConfig';
export var serviceTicketActionsEnum;
(function (serviceTicketActionsEnum) {
    serviceTicketActionsEnum["SERVICE_TICKET_REQUEST"] = "SERVICE_TICKET_REQUEST";
    serviceTicketActionsEnum["SERVICE_TICKET_SUCCESS"] = "SERVICE_TICKET_SUCCESS";
    serviceTicketActionsEnum["SERVICE_TICKET_ERROR"] = "SERVICE_TICKET_ERROR";
    serviceTicketActionsEnum["SELECT_SERVICE_TICKET"] = "SELECT_SERVICE_TICKET";
    serviceTicketActionsEnum["LOGIN_TO_VIEW"] = "LOGIN_TO_VIEW";
})(serviceTicketActionsEnum || (serviceTicketActionsEnum = {}));
export const loginToView = () => {
    return {
        type: serviceTicketActionsEnum.LOGIN_TO_VIEW
    };
};
export default function fetchTickets() {
    return (dispatch, getState) => {
        const { userState } = getState();
        if (userState && !userState.isLoggedIn)
            return dispatch(loginToView());
        dispatch({ type: serviceTicketActionsEnum.SERVICE_TICKET_REQUEST });
        const pathname = `/api/1/self-serve/helpcenter/incidents/customer`;
        return ApiCaller.get(Object.assign({}, baseConfig, {
            pathname,
            action: serviceTicketActionsEnum.SERVICE_TICKET_REQUEST
        })).then(data => {
            dispatch({
                type: serviceTicketActionsEnum.SERVICE_TICKET_SUCCESS,
                data: data.RESPONSE
            });
        }, error => {
            dispatch({ type: serviceTicketActionsEnum.SERVICE_TICKET_ERROR, error });
        });
    };
}
export const selectServiceTicket = issue => {
    return {
        type: serviceTicketActionsEnum.SELECT_SERVICE_TICKET,
        issue
    };
};
